export default "__VITE_ASSET__1e74af3e__"